(() => {
  const config = document.querySelector('[data-ild-addon-bridge]');
  if (!config || window.ildAddonBridgeInstalled) return;
  window.ildAddonBridgeInstalled = true;

  const root = config.dataset.root.replace(/\/?$/, '/');
  let current = null;
  let sequence = 0;
  let runtime = null;

  const fetchDocument = async url => {
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('catalog');
    return new DOMParser().parseFromString(
      await response.text(),
      'text/html'
    );
  };

  const eligible = async ids => {
    if (!ids.size) return false;

    let page = 1;
    let pages = 1;

    do {
      const url = `${root}collections/abiti-da-cerimonia?view=ild-addon-ids&page=${page}&_ild=${Date.now()}`;
      const doc = await fetchDocument(url);
      const node = doc.querySelector('[data-ild-collection-ids]');

      if (!node) return false;

      const data = JSON.parse(node.textContent);

      if (data.collection !== 'abiti-da-cerimonia') return false;
      if (data.ids.some(id => ids.has(String(id)))) return true;

      pages = Math.min(Number(data.pages) || 1, 100);
      page++;
    } while (page <= pages);

    return false;
  };

  const previous = window._COD_FORM_OVERWRITE_ON_SUBMIT_END;

  window._COD_FORM_OVERWRITE_ON_SUBMIT_END = function(order) {
    try {
      const token = ++sequence;
      const reference = String(order?.name || '').slice(0, 80);

      const ids = new Set(
        (order?.line_items || []).map(item => {
          const id =
            item.product?.id ||
            item.product_id ||
            item.variant?.product?.id ||
            '';

          return String(id).split('/').pop();
        }).filter(Boolean)
      );

      const eligibility = reference
        ? eligible(ids).catch(() => false)
        : Promise.resolve(false);

      current = {
        token,
        reference,
        requested: false,
        eligibility: eligibility.then(value => {
          if (config.dataset.simulation === 'true') {
            document.dispatchEvent(
              new CustomEvent('ild:addon-eligibility', {
                detail: { eligible: value }
              })
            );
          }
          return value;
        })
      };
    } catch (_) {
      current = null;
    }

    return typeof previous === 'function'
      ? previous.apply(this, arguments)
      : true;
  };

  const loadRuntime = () => {
    if (!runtime) {
      runtime = new Promise((resolve, reject) => {
        if (typeof window.ildInitAddons === 'function') {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = config.dataset.runtime;
        script.onload = resolve;
        script.onerror = () => {
          runtime = null;
          script.remove();
          reject(new Error('runtime'));
        };

        document.head.append(script);
      });
    }

    return runtime;
  };

  const showOffers = async context => {
    try {
      if (
        !await context.eligibility ||
        current !== context ||
        !context.requested
      ) return;

      if (document.querySelector('.ild-addon-overlay')) return;

      const catalogURL = `${root}collections/coprispalle-e-stole?view=ild-addons&_ild=${Date.now()}`;
      const doc = await fetchDocument(catalogURL);
      const app = doc.querySelector('[data-ild-addons]');

      if (!app || !app.querySelector('[data-models] [data-handle]')) {
        return;
      }

      await loadRuntime();

      if (current !== context) return;

      if (!document.querySelector('[data-ild-addon-style]')) {
        const style = document.createElement('link');
        style.rel = 'stylesheet';
        style.href = config.dataset.style;
        style.dataset.ildAddonStyle = '';

        await new Promise((resolve, reject) => {
          style.onload = resolve;
          style.onerror = reject;
          document.head.append(style);
        });
      }

      app.dataset.orderRef = context.reference;

      if (config.dataset.simulation === 'true') {
        app.dataset.demo = 'true';
      }

      app.dataset.catalog =
        `${root}collections/coprispalle-e-stole?view=ild-addons`;

      app.querySelector('.ild-received').textContent =
        `✓ Ordine ${context.reference} ricevuto`;

      const overlay = document.createElement('dialog');
      overlay.className = 'ild-addon-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Completa il tuo outfit');

      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'ild-addon-close';
      close.textContent = 'Torna al riepilogo ×';

      close.addEventListener('click', () => overlay.close());

      overlay.addEventListener('close', () => {
        overlay.remove();
        context.requested = false;
      });

      overlay.append(close, app);
      document.body.append(overlay);
      overlay.showModal();

      window.ildInitAddons(app);
      close.focus({ preventScroll: true });
    } catch (_) {
      context.requested = false;
    }
  };

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');

    if (!link || !current || current.requested) return;
    if (!link.closest('#_rsi-cod-form-modal-form')) return;

    let url;

    try {
      url = new URL(
        link.getAttribute('href').replace(/#/g, '%23'),
        location.origin
      );
    } catch (_) {
      return;
    }

    if (
      url.hostname !== 'wa.me' ||
      url.pathname.replace(/\D/g, '') !== '393274091483'
    ) return;

    const text = url.searchParams.get('text') || '';

    if (
      !text.includes(current.reference) ||
      !/confermo\s+ordine/i.test(text)
    ) return;

    link.href = url.href;
    current.requested = true;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    const context = current;
    setTimeout(() => showOffers(context), 0);
  }, true);
})();